const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins
class PushCartRecommendations extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.type = this.dataset.pushcartUpsellType
    this.collection = this.dataset.pushcartUpsellCollection

    window.setTimeout(() => this.render(), 500)
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.expanded = false
  }

  render () {
    if (this.type === 'standard') {
      this.renderSearchAndDiscovery()
    } else if (this.type === 'collection') {
      this.renderCollection()
    }
  }

  async renderSearchAndDiscovery () {
    if (!this.url) {
      this.expanded = false
      return
    }

    try {
      const response = await fetch(this.url)
      const text = await response.text()

      const html = document.createElement('div')
      html.innerHTML = text

      const recommendations = html.querySelector('push-cart-recommendations')
      const hasItems = recommendations?.querySelector(
        '.psh-CartRecommendations_Item',
      )

      if (hasItems) {
        const containers = document.querySelectorAll(
          '.psh-CartRecommendations',
        )
        for (const container of containers) {
          container.innerHTML = recommendations.innerHTML
        }
      }

      const shouldExpand = Boolean(hasItems)
      this.expanded = shouldExpand
    } catch (e) {
      console.error(e)
    }
  }

  renderCollection () {
    if (!this.collection) {
      this.expanded = false
    }

    const products = document.querySelectorAll(
      '[data-push-cart-carousel-el="slide"]',
    )
    if (products) {
      this.expanded = true
    }
  }

  get expanded () {
    return this._expanded
  }

  set expanded (expanded) {
    this._expanded = expanded

    document
      .querySelector('site-drawer[key="cart"] .drw-Drawer_Aside')
      ?.setAttribute('aria-expanded', expanded)

    document
      .querySelector('.psh-Cart_Recommendations')
      ?.setAttribute('loaded', expanded)
  }

  get url () {
    return this.dataset.url
  }
}

if (!customElements.get('push-cart-recommendations')) {
  customElements.define('push-cart-recommendations', PushCartRecommendations)
}

class PushCartCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    window.setTimeout(() => this.render(), 500)
  }

  render () {
    if (!this.els?.slide?.exists) return

    if (window.BAO.MediaBreakpoints.isMd) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.3,
          spacing: 10,
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('push-cart-carousel')) {
  customElements.define('push-cart-carousel', PushCartCarousel)
}
